import React, { useState, useCallback, useEffect } from 'react';
import { Container, Row, Col, CloseButton } from 'react-bootstrap';
import { useCookieConsent } from 'use-cookie-consent';

import { Button } from 'components/common';

import {
  grantConsent as grantFbqConsent,
  revokeConsent as revokeFbqConsent,
} from 'lib/fb-pixel';
import useMediaQuery from 'hooks/useMediaQuery';
import {
  grantOpenAIPixelConsent,
  revokeOpenAIPixelConsent,
} from 'lib/open-ai-pixel';

const CookieConsent = () => {
  const {
    acceptAllCookies,
    declineAllCookies,
    didAcceptAll,
    didDeclineAll,
  } = useCookieConsent();

  const [showCookieBanner, setShowCookieBanner] = useState(false);

  const handleAcceptCookieConsent = useCallback(() => {
    setShowCookieBanner(false);
    acceptAllCookies();
  }, [acceptAllCookies]);

  const handleDeclineCookieConsent = useCallback(() => {
    setShowCookieBanner(false);
    declineAllCookies();
  }, [declineAllCookies]);

  const grantThirdPartyCookies = useCallback(() => {
    grantFbqConsent();
    grantOpenAIPixelConsent();
  }, []);

  const revokeThirdPartyCookies = useCallback(() => {
    revokeFbqConsent();
    revokeOpenAIPixelConsent();
  }, []);

  useEffect(() => {
    const handleCookieConsent = () => {
      const notAcceptedNorDeclined =
        didAcceptAll() && didDeclineAll(); // if not yet accepted or declined, both of the values will be `true` from 'use-cookie-consent'

      if (notAcceptedNorDeclined) {
        setShowCookieBanner(true);
        return;
      }

      if (didAcceptAll()) {
        grantThirdPartyCookies();
        return;
      }

      if (didDeclineAll()) {
        revokeThirdPartyCookies();
        return;
      }
    };

    handleCookieConsent();
  }, [
    didAcceptAll,
    didDeclineAll,
    grantThirdPartyCookies,
    revokeThirdPartyCookies,
  ]);

  const isViewPortSmall = useMediaQuery('(max-width: 480px)');
  const isPointerCoarse = useMediaQuery('(pointer: coarse)');

  if (!showCookieBanner) return null;

  const isMobile = isViewPortSmall && isPointerCoarse;

  return (
    <div
      style={{
        position: isMobile ? 'fixed' : 'sticky',
        bottom: 0,
        left: 0,
        right: isMobile ? 0 : undefined,
        zIndex: 99,
        backgroundColor: '#fff',
        boxShadow: '0 -3px 6px rgb(51 51 51 / 5%)',
      }}
    >
      <Container>
        <Row
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '1.8rem 0',
          }}
        >
          <Col xs={12} md={8}>
            <h4 style={{ marginBottom: '0.5rem' }}>
              Low-Fat Cookies
            </h4>
            <p
              style={{
                marginBottom: '1rem',
                fontSize: '1.3rem',
                lineHeight: isMobile ? '1.1' : '1.5rem',
              }}
            >
              This website uses cookies to enhance user experience and
              to analyze performance and traffic on our website
              (including tools such as Google Analytics and Microsoft
              Clarity). We also share information about your use of
              our site with our social media, advertising and
              analytics partners.{' '}
            </p>
          </Col>
          <Col
            xs="auto"
            style={{
              display: 'flex',
              alignItems: 'center',
              width: isMobile ? '100%' : undefined,
            }}
          >
            <Button
              color="secondary"
              onClick={handleAcceptCookieConsent}
            >
              ACCEPT
            </Button>
            <div style={{ marginLeft: isMobile ? 'auto' : '12px' }}>
              <CloseButton
                onClick={handleDeclineCookieConsent}
                style={{
                  fontSize: '24px',
                  paddingRight: isMobile ? '16px' : undefined,
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

CookieConsent.propTypes = {};

export default CookieConsent;
